/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AutomationSettingsEntrypointProps } from './AutomationSettings.entrypoint.types.tsx';

type AutomationSettingsEntryPointComponent = EntryPointComponent<
	{},
	{},
	AutomationSettingsEntrypointProps,
	{}
>;

export const automationSettingsEntryPoint: EntryPoint<AutomationSettingsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<AutomationSettingsEntryPointComponent>(
			/* webpackChunkName: "async-itam-settings-automation" */ './AutomationSettings.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
